// 
import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useReducer, useRef, useState } from "react"
import { ImageStyle, Platform, ScrollView, TextStyle, ViewStyle, SafeAreaView, FlatList, Alert, Dimensions, RefreshControl, StyleSheet } from "react-native"
import { api } from "../../../../../services/api"
import { colors, spacing } from "../../../../../theme"
import { View, Text, TextField, Card, Checkbox, DateTimePicker, Picker, SegmentedControl, Assets, Spacings, Colors, BorderRadiuses, Timeline, GridList, GridView, Modal, SortableList, SortableGridList, Image, Button, TabController, Avatar, TouchableOpacity, Carousel } from 'react-native-ui-lib';
import DynamicForm, { Col, CustomModal, CustomNumberInput, CustomSelect, DangerButton, Heading, Row, SecondaryButton, CustomTextField, Label, CustomCheckbox, PrimaryButton } from "../../../../../mycomponents/DynamicForm"
import DynamicTable from "../../../../../mycomponents/DynamicTable"
import { useNavigate, useParams } from "react-router-dom"
import { useStores } from "../../../../../mycomponents/state"
import { useNavigationState, useNavigation } from "@react-navigation/native"
import LayoutScreen from "../../../../../mycomponents/CRUD/LayoutScreen"
import FormScreen from "../../../../../mycomponents/CRUD/FormScreen"
import {
    LineChart,
    BarChart,
    PieChart,
    ProgressChart,
    ContributionGraph,
    StackedBarChart
} from "react-native-chart-kit";
import { QueryBuilder } from 'react-querybuilder';
import { QueryBuilderNative } from '@react-querybuilder/native';
import { App } from 'antd';
import { Agenda, DateData, AgendaEntry, AgendaSchedule, CalendarList } from 'react-native-calendars';
import { LinearGradient } from "expo-linear-gradient"
import { GlobalMasterStore } from "../../../../../mycomponents/state/PermissionStore"
import { Icon } from "react-native-eva-icons"
import { MainScannerScreenComponent } from "../../../../../mycomponents/CRUD/ListingScreen"
import * as Location from 'expo-location';
import { FlashList } from "@shopify/flash-list"
import dayjs from "dayjs"
import { Camera, CameraType } from 'expo-camera';
import FaceAuth from "./FaceAuth/FaceAuth"
import Svg, { G, Path } from "react-native-svg"
import { GlobalModalStore } from "../../../../../mycomponents/state/ModalStore"
import { CustomSelectItemForContacts } from "../../../../../models/accountancy/transaction"
import HomeDashboard from "./HomeDashboard"
import { AppointmentsComponent, BillsComponentIcon, BroadcastComponentIcon, CashInComponentIcon, CashOutComponentIcon, DebitNotesComponentIcon, ItemsComponentIcon, KitchenComponentIcon, LeadsComponentIcon, MoneyTrasnferComponentIcon, PosComponentIcon, ProductionOrderComponent, ProductionWorkflowIconComponent, SalesComponentIcon, SalesDashboardComponentIcon, SalesReturnComponentIcon, TableManagementComponentIcon } from "./HomeIcons"
const tinycolor = require("tinycolor2");


const filterIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            fill="#000"
            fillRule="evenodd"
            d="M15 10.5A3.502 3.502 0 0 0 18.355 8H21a1 1 0 1 0 0-2h-2.645a3.502 3.502 0 0 0-6.71 0H3a1 1 0 0 0 0 2h8.645A3.502 3.502 0 0 0 15 10.5zM3 16a1 1 0 1 0 0 2h2.145a3.502 3.502 0 0 0 6.71 0H21a1 1 0 1 0 0-2h-9.145a3.502 3.502 0 0 0-6.71 0H3z"
            clipRule="evenodd"
        />
    </Svg>
)

const deleteIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 12v5M14 12v5M4 7h16M6 10v8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-8M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2H9V5Z"
        />
    </Svg>
)

const HamIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        viewBox="0 0 24 24"
        {...props}
    >
        <G fill="none" fillRule="evenodd">
            <Path d="M0 0h24v24H0z" />
            <Path
                stroke="#0C0310"
                strokeLinecap="round"
                strokeWidth={2}
                d="M5 7h14M5 17h14M5 12h14"
            />
        </G>
    </Svg>
)

const plusIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 12h16m-8-8v16"
        />
    </Svg>
)

const minusIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 12h12"
        />
    </Svg>
)

const boxIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            fill="#080341"
            fillRule="evenodd"
            d="m12 3.663 8.25 4.077v9.27L12 21.086 3.75 17.01V7.74L12 3.663Zm-6.75 5.75v6.665l6 2.965v-6.665l-6-2.965Zm7.5 2.965v6.665l6-2.965V9.413l-2.25 1.112V13.5l-1.5.75v-2.984l-2.25 1.112Zm5.057-4.172-1.954.965a.75.75 0 0 0-.142-.092L10.1 6.275 12 5.336l5.807 2.87ZM8.415 7.108l5.772 2.886L12 11.075l-5.807-2.87 2.222-1.097Z"
            clipRule="evenodd"
        />
    </Svg>
)

const paymentIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="-0.5 0 25 25"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M18.92 7.97c.058-.387.085-.778.08-1.17a12.49 12.49 0 0 0-18 0c0 14.06 9 16.17 9 16.17a13.574 13.574 0 0 0 1.92-1M23 13.97H13"
        />
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M21 10.92h-6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2Z"
        />
    </Svg>
)

const returnIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 48 48"
        {...props}
    >
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="m13 8-7 6 7 7"
        />
        <Path
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="M6 14h22.994c6.883 0 12.728 5.62 12.996 12.5.284 7.27-5.723 13.5-12.996 13.5H11.998"
        />
    </Svg>
)

const supportIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={800}
        height={800}
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <Path
            stroke="#1C274C"
            strokeLinecap="round"
            strokeWidth={1.5}
            d="M8 9h8M8 12.5h5.5"
        />
        <Path
            fill="#1C274C"
            d="m13.087 21.388.645.382-.645-.382Zm.542-.916-.646-.382.646.382Zm-3.258 0-.645.382.645-.382Zm.542.916.646-.382-.646.382ZM1.25 10.5a.75.75 0 0 0 1.5 0h-1.5Zm1.824 5.126a.75.75 0 0 0-1.386.574l1.386-.574Zm4.716 3.365-.013.75.013-.75Zm-2.703-.372-.287.693.287-.693Zm16.532-2.706.693.287-.693-.287Zm-5.409 3.078-.012-.75.012.75Zm2.703-.372.287.693-.287-.693Zm.7-15.882-.392.64.392-.64Zm1.65 1.65.64-.391-.64.392ZM4.388 2.738l-.392-.64.392.64Zm-1.651 1.65-.64-.391.64.392ZM9.403 19.21l.377-.649-.377.649Zm4.33 2.56.541-.916-1.29-.764-.543.916 1.291.764Zm-4.007-.916.542.916 1.29-.764-.541-.916-1.291.764Zm2.715.152a.52.52 0 0 1-.882 0l-1.291.764c.773 1.307 2.69 1.307 3.464 0l-1.29-.764ZM10.5 2.75h3v-1.5h-3v1.5Zm10.75 7.75v1h1.5v-1h-1.5ZM7.803 18.242c-1.256-.022-1.914-.102-2.43-.316L4.8 19.313c.805.334 1.721.408 2.977.43l.026-1.5ZM1.688 16.2A5.75 5.75 0 0 0 4.8 19.312l.574-1.386a4.25 4.25 0 0 1-2.3-2.3l-1.386.574Zm19.562-4.7c0 1.175 0 2.019-.046 2.685-.045.659-.131 1.089-.277 1.441l1.385.574c.235-.566.338-1.178.389-1.913.05-.729.049-1.632.049-2.787h-1.5Zm-5.027 8.241c1.256-.021 2.172-.095 2.977-.429l-.574-1.386c-.515.214-1.173.294-2.428.316l.025 1.5Zm4.704-4.115a4.25 4.25 0 0 1-2.3 2.3l.573 1.386a5.75 5.75 0 0 0 3.112-3.112l-1.386-.574ZM13.5 2.75c1.651 0 2.837 0 3.762.089.914.087 1.495.253 1.959.537l.783-1.279c-.739-.452-1.577-.654-2.6-.752-1.012-.096-2.282-.095-3.904-.095v1.5Zm9.25 7.75c0-1.622 0-2.891-.096-3.904-.097-1.023-.299-1.862-.751-2.6l-1.28.783c.285.464.451 1.045.538 1.96.088.924.089 2.11.089 3.761h1.5Zm-3.53-7.124a4.25 4.25 0 0 1 1.404 1.403l1.279-.783a5.75 5.75 0 0 0-1.899-1.899l-.783 1.28ZM10.5 1.25c-1.622 0-2.891 0-3.904.095-1.023.098-1.862.3-2.6.752l.783 1.28c.464-.285 1.045-.451 1.96-.538.924-.088 2.11-.089 3.761-.089v-1.5ZM2.75 10.5c0-1.651 0-2.837.089-3.762.087-.914.253-1.495.537-1.959l-1.279-.783c-.452.738-.654 1.577-.752 2.6C1.25 7.61 1.25 8.878 1.25 10.5h1.5Zm1.246-8.403a5.75 5.75 0 0 0-1.899 1.899l1.28.783a4.25 4.25 0 0 1 1.402-1.403l-.783-1.279Zm7.02 17.993c-.202-.343-.38-.646-.554-.884a2.229 2.229 0 0 0-.682-.645l-.754 1.297c.047.028.112.078.224.232.121.166.258.396.476.764l1.29-.764Zm-3.24-.349c.44.008.718.014.93.037.198.022.275.054.32.08l.754-1.297c-.293-.17-.598-.24-.909-.274-.298-.033-.657-.038-1.069-.045l-.025 1.5Zm6.498 1.113c.218-.367.355-.598.476-.764.112-.154.177-.204.224-.232l-.754-1.297c-.29.17-.5.395-.682.645-.173.238-.352.54-.555.884l1.291.764Zm1.924-2.612c-.412.007-.771.012-1.069.045-.311.035-.616.104-.909.274l.754 1.297c.045-.026.122-.058.32-.08.212-.023.49-.03.93-.037l-.026-1.5Z"
        />
    </Svg>
)

const heartIcon = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 109.57",
        }}
        viewBox="0 0 122.88 109.57"
        {...props}
    >
        <Path d="M65.46 19.57c-.68.72-1.36 1.45-2.2 2.32l-2.31 2.41-2.4-2.33c-.71-.69-1.43-1.4-2.13-2.09C49 12.58 43.41 7.08 31.9 6.93c-.45-.01-.93 0-1.43.02-6.44.23-12.38 2.6-16.72 6.65-4.28 4-7.01 9.67-7.1 16.57-.01.43 0 .88.02 1.37.69 19.27 19.13 36.08 34.42 50.01 2.95 2.69 5.78 5.27 8.49 7.88l11.26 10.85 14.15-14.04c2.28-2.26 4.86-4.73 7.62-7.37 4.69-4.5 9.91-9.49 14.77-14.52 3.49-3.61 6.8-7.24 9.61-10.73 2.76-3.42 5.02-6.67 6.47-9.57 2.38-4.76 3.13-9.52 2.62-13.97-.5-4.39-2.23-8.49-4.82-11.99a28.623 28.623 0 0 0-10.14-8.5C96.5 7.29 91.21 6.2 85.8 6.82c-9.33 1.08-14.3 6.35-20.34 12.75zm-4.69-4.72C67.67 7.54 73.4 1.55 85.04.22c6.72-.77 13.3.57 19.03 3.45 4.95 2.48 9.27 6.1 12.51 10.47 3.27 4.42 5.46 9.61 6.1 15.19.65 5.66-.29 11.69-3.3 17.69-1.7 3.39-4.22 7.03-7.23 10.76-2.95 3.66-6.39 7.44-10 11.17-4.95 5.13-10.21 10.17-14.95 14.71-2.77 2.65-5.36 5.13-7.54 7.29L63.2 107.28l-2.31 2.29-2.34-2.25-13.6-13.1c-2.49-2.39-5.37-5.02-8.36-7.75C20.38 71.68.81 53.85.02 31.77 0 31.23 0 30.67 0 30.09c.12-8.86 3.66-16.18 9.21-21.36C14.71 3.6 22.18.6 30.22.31c.55-.02 1.13-.03 1.74-.02C46 .48 52.42 6.63 60.77 14.85z" />
    </Svg>
)

const heartFill = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 122.88 107.41",
        }}
        viewBox="0 0 122.88 107.41"
        {...props}
    >
        <Path
            d="M60.83 17.19C68.84 8.84 74.45 1.62 86.79.21c23.17-2.66 44.48 21.06 32.78 44.41-3.33 6.65-10.11 14.56-17.61 22.32-8.23 8.52-17.34 16.87-23.72 23.2l-17.4 17.26-14.38-13.84C29.16 76.9.95 55.93.02 29.95-.63 11.75 13.73.09 30.25.3c14.76.2 20.97 7.54 30.58 16.89z"
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
        />
    </Svg>
)


const isDesktop = Dimensions.get('window').width >= 768;


const FieldSelector = (props) => {
    const options = props.options;

    return (
        <CustomSelect
            placeholder="Select a field"
            value={props.value}
            onChange={(value) => {
                props.handleOnChange(value);
            }}
            options={options}
        />
    );
};

const operatorSelector = (props) => {
    const options = props.options;

    return (
        <CustomSelect
            placeholder="Select an operator"
            value={props.value}
            onChange={(value) => {
                props.handleOnChange(value);
            }}
            options={options}
        />
    );
}

const EmployeeBalanceCard = ({ refreshCount, employee_id, employee }) => {
    const [balance, setBalance] = useState(0);

    const getEmployeeBalance = async () => {
        try {
            const response = await api.customRoute('homeCard/EmployeeBalance', {
                employee_id: employee_id,
            });

            setBalance(response.balance || 0);
        } catch (e) {

        }
    }

    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    useEffect(() => {
        getEmployeeBalance();
    }, [refreshCount]);

    return <View padding-10 style={{ width: Platform.OS == 'web' ? 300 : '100%' }}><Card padding-10 style={{
        width: Platform.OS == 'web' ? 300 : '100%',
    }}>
        <View row centerV>
            <View marginR-10>
                <Image source={{ uri: `https://cdn-icons-png.flaticon.com/512/9308/9308895.png` }} style={{ width: 50, height: 50 }} />
            </View>
            <View>
                <View marginT-0 marginB-0>
                    <Text tabHeading>Your Balance</Text>
                </View>
                <View marginT-5>
                    <Text h1 style={{
                        fontSize: 22,
                    }}>Rs. {balance}</Text>
                </View>
            </View>
        </View>
        <DangerButton style={{
            flex: Platform.OS == 'web' ? 1 : 0,
            marginTop: 20,
        }} onPress={async () => {
            navigationFn("report/Ledger", {
                hideQuickFilter: true,
                quickFilterValue: employee.account_id,
                quickFilterKey: "account_id"
            })
        }} >
            <View row center>
                <View marginR-5>
                    <Icon name="file-text-outline" width={20} height={20} fill="rgb(29, 78, 195)" />
                </View>
                <Text style={{ color: 'rgb(29, 78, 195)', fontFamily: 'SourceSansProSemiBold' }}>View Statement</Text>
            </View>
        </DangerButton>
    </Card></View>;
}

const CollectionSummaryCard = ({ refreshCount, employee_id, employee }) => {
    const [balance, setBalance] = useState(0);

    const getEmployeeBalance = async () => {
        try {
            const response = await api.customRoute('getReport', {
                "reportName": "DayBookByEmployee",
                "page": 1,
                "limit": 200000,
                "sortColumn": "",
                "sortDirection": "",
                "filters": [],
                "search": "",
                "groupBy": null,
                "startDate": new Date(),
                "endDate": new Date(),
                "employee_id": employee_id,
            });

            const transactions = response.data.data;

            let amount = 0;

            if (transactions && transactions.length > 0) {
                const total_payment_received_transaction = transactions.find((el) => el.transaction_type == "Closing Cash In Hand")

                if (total_payment_received_transaction) {
                    amount = total_payment_received_transaction.debit ? total_payment_received_transaction.debit : total_payment_received_transaction.credit;
                }
            }

            setBalance(amount);
        } catch (e) {
            setBalance(0);
        }
    }

    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    useEffect(() => {
        getEmployeeBalance();
    }, [refreshCount]);

    return <View padding-10 style={{ width: Platform.OS == 'web' ? 300 : '100%' }}>
        <Card padding-10 style={{
            width: Platform.OS == 'web' ? 300 : '100%',
        }}>
            <View row centerV>
                <View marginR-10>
                    <Image source={{ uri: `https://cdn-icons-png.flaticon.com/512/9308/9308895.png` }} style={{ width: 50, height: 50 }} />
                </View>
                <View>
                    <View marginT-0 marginB-0>
                        <Text tabHeading>Today's Collection</Text>
                    </View>
                    <View marginT-5>
                        <Text h1 style={{
                            fontSize: 22,
                        }}>Rs. {balance}</Text>
                    </View>
                </View>
            </View>
            <DangerButton style={{
                flex: Platform.OS == 'web' ? 1 : 0,
                marginTop: 20,
            }} onPress={async () => {
                navigationFn("report/DayBookByEmployee", {
                    // hideQuickFilter: true,
                    quickFilterValue: employee_id,
                    quickFilterKey: "employee_id"
                })
            }} >
                <View row center>
                    <View marginR-5>
                        <Icon name="file-text-outline" width={20} height={20} fill="rgb(29, 78, 195)" />
                    </View>
                    <Text style={{ color: 'rgb(29, 78, 195)', fontFamily: 'SourceSansProSemiBold' }}>View Day Book</Text>
                </View>
            </DangerButton>
        </Card></View>;
}

const GlobalCollectionSummaryCard = ({ refreshCount, employee_id, employee }) => {
    const [balance, setBalance] = useState(0);

    const getEmployeeBalance = async () => {
        try {
            const response = await api.customRoute('getReport', {
                "reportName": "PaymentCollectionByEmployee",
                "page": 1,
                "limit": 200000,
                "sortColumn": "",
                "sortDirection": "",
                "filters": [],
                "search": "",
                "groupBy": null,
                "startDate": new Date(),
                "endDate": new Date(),
            });

            const transactions = response.data.data;

            let amount = 0;

            if (transactions && transactions.length > 0) {
                amount = transactions.reduce((acc, el) => {
                    return acc + (el.total_amount || 0);
                }, 0);
            }

            setBalance(amount);
        } catch (e) {
            setBalance(0);
        }
    }

    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    useEffect(() => {
        getEmployeeBalance();
    }, [refreshCount]);

    return <View padding-10 style={{ width: Platform.OS == 'web' ? 300 : '100%' }}>
        <Card padding-10 style={{
            width: Platform.OS == 'web' ? 300 : '100%',
        }}>
            <View row centerV>
                <View marginR-10>
                    <Image source={{ uri: `https://cdn-icons-png.flaticon.com/512/9308/9308895.png` }} style={{ width: 50, height: 50 }} />
                </View>
                <View>
                    <View marginT-0 marginB-0>
                        <Text tabHeading>Today's Collection</Text>
                    </View>
                    <View marginT-5>
                        <Text h1 style={{
                            fontSize: 22,
                        }}>Rs. {balance}</Text>
                    </View>
                </View>
            </View>
            <DangerButton style={{
                flex: Platform.OS == 'web' ? 1 : 0,
                marginTop: 20,
            }} onPress={async () => {
                navigationFn("report/PaymentCollectionByEmployee", {
                })
            }} >
                <View row center>
                    <View marginR-5>
                        <Icon name="file-text-outline" width={20} height={20} fill="rgb(29, 78, 195)" />
                    </View>
                    <Text style={{ color: 'rgb(29, 78, 195)', fontFamily: 'SourceSansProSemiBold' }}>View Payment Collection</Text>
                </View>
            </DangerButton>
        </Card></View>;
}

const TodaysAttendanceCard = ({ employee, style = {}, refreshCount, displayAddress, nearestLocationId, actualLatitude, actualLongitude }) => {
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);

    const [isCheckedIn, setIsCheckedIn] = useState(null);
    const [faceAuthModalVisible, setFaceAuthModalVisible] = useState(false);

    const { message } = App.useApp();
    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    const getCheckInStatus = async () => {
        if (employee?._id) {
            const response = await api.customRoute('AttendanceRegister/action', {
                action: 'getCheckInStatus',
                employee_id: employee?._id,
            });

            setIsCheckedIn(response.is_checked_in);
        }
    };

    const getTodaysAttendance = async () => {
        try {
            const response = await api.customRoute('homeCard/TodaysAttendance', {
                employee_id: employee?._id,
            });

            setCheckIn(response.check_in);
            setCheckOut(response.check_out);
        } catch (e) {

        }
    }

    useEffect(() => {
        getTodaysAttendance();
    }, [isCheckedIn]);

    useEffect(() => {
        getCheckInStatus();
    }, [employee?._id, refreshCount]);

    const [status, requestPermission] = Camera.useCameraPermissions();

    useEffect(() => {
        if (status?.granted) {
        } else {
            requestPermission();
        }
    }, []);

    const checkInFn = async (photo) => {
        const response = await api.customRoute('AttendanceRegister/action', {
            action: 'checkIn',
            employee_id: employee?._id,
            latitude: actualLatitude,
            longitude: actualLongitude,
            location_name: displayAddress,
            location_id: nearestLocationId,
            remark: "No Remarks",
            photo: photo,
        });

        if (Platform.OS === 'web') {
            message.info(response.message);
        } else {
            Alert.alert(response.message);
        }

        getCheckInStatus();
    };

    const checkOutFn = async () => {
        const response = await api.customRoute('AttendanceRegister/action', {
            action: 'checkOut',
            latitude: actualLatitude,
            longitude: actualLongitude,
            location_name: displayAddress,
            location_id: nearestLocationId,
            employee_id: employee?._id,
            remark: "No Remarks"
        });

        if (Platform.OS === 'web') {
            message.info(response.message);
        } else {
            Alert.alert(response.message);
        }
        getCheckInStatus();
    };

    return <View padding-10 style={{ width: Platform.OS == 'web' ? 300 : '100%' }}><Card padding-10 style={{
        width: Platform.OS == 'web' ? 300 : '100%',
        ...(style || {})
    }}>
        <View row>
            <View row>
                <View marginR-10>
                    <Icon name="clock-outline" width={25} height={25} fill="#195ad2" />
                </View>
                <View marginR-10>
                    <View marginT-0 marginB-0>
                        <Text tabHeading>Check In</Text>
                    </View>
                    <View marginT-5>
                        <Text h1 style={{
                            fontSize: 22,
                        }}>
                            {checkIn ? dayjs(checkIn).format("HH:mm") : "-"}
                        </Text>
                    </View>
                </View>
            </View>
            <View row>
                <View marginR-10>
                    <Icon name="clock-outline" width={25} height={25} fill="#dc3f4d" />
                </View>
                <View>
                    <View marginT-0 marginB-0>
                        <Text tabHeading>Check Out</Text>
                    </View>
                    <View marginT-5>
                        <Text h1 style={{
                            fontSize: 22,
                        }}>
                            {checkOut ? dayjs(checkOut).format("HH:mm") : "-"}
                        </Text>
                    </View>
                </View>
            </View>
        </View>
        <View style={{
            minWidth: 200,
            marginTop: Platform.OS == 'web' ? 20 : 20,
        }}>
            {isCheckedIn == false && <DangerButton style={{
                // marginRight: 5,
                flex: Platform.OS == 'web' ? 1 : 0,
            }} onPress={() => {
                setFaceAuthModalVisible(true)
            }}>
                <View row center>
                    <View marginR-5>
                        <Icon name="log-in-outline" width={20} height={20} fill="rgb(29, 78, 195)" />
                    </View>
                    <Text style={{ color: 'rgb(29, 78, 195)', fontFamily: 'SourceSansProSemiBold' }}>CHECK IN</Text>
                </View>
            </DangerButton>}
            {isCheckedIn == true && <DangerButton style={{
                flex: Platform.OS == 'web' ? 1 : 0,
            }} onPress={checkOutFn} >
                <View row center>
                    <View marginR-5>
                        <Icon name="log-out-outline" width={20} height={20} fill="#b60505" />
                    </View>

                    <Text style={{ color: '#b60505', fontFamily: 'SourceSansProSemiBold' }}>CHECK OUT</Text>
                </View>
            </DangerButton>}
        </View>

        <CustomModal title="Check In" width="100%" visible={faceAuthModalVisible} onClose={() => {
            setFaceAuthModalVisible(false);
        }}>
            <View style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                minHeight: Dimensions.get("window").height - 100,
            }}>
                <View marginT-10 marginB-10 spread row marginH-20>
                    <Text h1>Face Authentication</Text>
                    <SecondaryButton onPress={() => {
                        setFaceAuthModalVisible(false);
                    }}>
                        <Text>Cancel</Text>
                    </SecondaryButton>
                </View>
                <FaceAuth employee={employee} onAuthenticated={(photo) => {
                    setFaceAuthModalVisible(false);
                    checkInFn(photo);
                }} />
            </View>
        </CustomModal>
    </Card></View>;
}

const FindItemScreenComponent = (props) => {
    const [contactId, setContactId] = useState(null);
    const [contacts, setContacts] = useState([]);

    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [allColumns, setAllColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);

    const getCreateData = async () => {
        const response = await api.getCreateData("Invoices", {});

        setContacts(response?.Contacts || []);
    }

    useEffect(() => {
        getCreateData();
    }, []);

    const getReport = async () => {
        const response = await api.customRoute('getReport', {
            "reportName": "FindSerialNumbersByContactOrSerialNumber",
            "page": 1,
            "limit": 200000,
            "sortColumn": "",
            "sortDirection": "",
            "filters": [],
            "search": "",
            "groupBy": null,
            "startDate": new Date(),
            "endDate": new Date(),
            "contact_id": contactId,
        });

        let { data, all_columns = [], selected_columns = [], filters } = response;
        setRows(data?.data || []);
        setTotal(data?.total || 0);

        selected_columns = selected_columns.filter((column) => {
            if (!column.field) {
                return false;
            }
            if (column.accessor == "actions") {
                return false;
            }
            column.Header = column.label;
            column.accessor = column.field;

            if (column.width) {
                const width = "" + column.width;
                column.width = width.replace('px', '');
            }

            return true;
        });

        if (selected_columns.length === all_columns.length) {
            selected_columns = selected_columns.filter((col) => col.visible);
        }

        selected_columns.push({ Header: (props) => null, accessor: 'actions', width: 75, minWidth: 75 });

        const allColumns = all_columns.map((col, index) => ({
            ...col,
            id: index,
            visible: selected_columns.find((c) => c.field === col.field) ? true : false,
            width: selected_columns.find((c) => c.field === col.field) ? selected_columns.find((c) => c.field === col.field).width : 150,
        }))

        setAllColumns(allColumns || []);
        setSelectedColumns(selected_columns || []);
    }

    const saveColumns = async (columns, reload = true) => {
        await api.customRoute("saveColumnsReports/" + "FindSerialNumbersByContactOrSerialNumber", {
            columns: columns,
        });

        if (reload) {
            setTimeout(() => {
                getReport();
            }, 0);
        }
    }

    useEffect(() => {
        getReport();
    }, [contactId]);

    return <View flex style={{
        width: '100%',
    }}>
        <CustomSelect
            placeholder="Select a contact"
            value={contactId}
            onChange={(value) => {
                setContactId(value);
            }}
            options={contacts}
            otherSearchKeys={['phone', 'email']}
            customSelectItem={CustomSelectItemForContacts}
        />

        <View marginT-10 style={{
            width: '100%',
            height: 500
        }}>
            <DynamicTable
                data={rows}
                columns={selectedColumns}
                allColumns={allColumns}
                hideLabelOnMobile={true}
                cfAdd={true}
                saveColumns={saveColumns}
                isGrouped={false}
                mono={false}
                // total={total}
                // pageSize={pageSize}
                // pageIndex={pageIndex}
                // onQueryParams={onQueryParams}
                // showCheckbox={true}
                resizable={true}
            />
        </View>
    </View>
};

const ExternalLinkIcon = (props) => <View style={{
    position: 'absolute',
    right: 6,
    top: 6,
}}>
    <Icon name="external-link-outline" width={14} height={14} fill="white" />
</View>;

const CustomCard = ({ permission, onPress, backgroundColor, Icon, textSize, textLabel }) => {
    if (!permission) return null;


    return (
        <Card
            // enableShadow={false}
            borderRadius={Platform.OS == 'web' ? 0 : 15}
            onPress={onPress}
            center
            style={{
                height: 85,
                width: '100%',
                position: 'relative',
                backgroundColor: Platform.OS == 'web' ? backgroundColor : 'white',
                // borderWidth: 1,
                // borderColor: '#dedede',
                // borderTopWidth: 5,
                // borderTopColor: backgroundColor,
            }}
        >
            <View paddingH-16 center style={{ width: '100%' }}>
                <View style={{
                    transform: [{ scale: Platform.OS == 'web' ? 1 : 0.7 }],
                }}>
                    <Icon color={Platform.OS == 'web' ? 'white' : "rgb(52, 152, 219)"} />
                </View>
                <Text
                    marginT-5
                    tabHeading
                    style={{
                        textAlign: 'center',
                        fontSize: Platform.OS != 'web' ? 10 : textSize,
                        fontFamily: 'SourceSansProSemiBold',
                        color: Platform.OS == 'web' ? 'white' : 'black',
                    }}
                >
                    {textLabel}
                </Text>
            </View>
            {Platform.OS == 'web' && <ExternalLinkIcon />}
        </Card>
    );
};

const HomeScreen = observer(function HomeScreen(props) {
    const permissions = GlobalMasterStore((state) => state.permissions);
    const employee = GlobalMasterStore((state) => state.employee);
    const [primaryColor, setPrimaryColor] = useState("#cab78d");
    const setOpenModal = GlobalModalStore((state) => state.setOpenModal);
    const organization_id = GlobalMasterStore((state) => state.globalData.organization_id);

    const { message } = App.useApp();

    let navigation = useNavigation();
    let navigate = null;

    if (Platform.OS === 'web') {
        navigate = useNavigate();
    }

    const navigationFn = (path, params) => {
        if (Platform.OS === 'web') {
            let paramsString = "";
            if (params) {
                paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
            }
            navigate("/" + path + paramsString);
        } else {
            if (path.includes("report/")) {
                navigation.navigate("report", {
                    ...params,
                    name: path.replace("report/", ""),
                });
            } else {
                navigation.navigate(path, params);
            }
        }
    };

    const MainWrapper = useCallback(({ children }) => {
        return !props.hideWrapper ? <>
            <LayoutScreen>
                {Platform.OS == 'web' && <View marginT-2 style={{
                    flex: 1,
                    // backgroundColor: 'red'
                }} padding-20>
                    <Card padding-10>
                        {children}
                    </Card>
                </View>}

                {Platform.OS != 'web' && <View marginT-2 style={{
                    flex: 1,
                }} padding-10>
                    {children}
                </View>}

            </LayoutScreen>
        </> : <>
            {children}
        </>
    }, [])

    const [showScanner, setShowScanner] = useState(false);
    const [showFindItem, setShowFindItem] = useState(false);
    const [scannerValue, setScannerValue] = useState(null);
    const [fetchingLocation, setFetchingLocation] = useState(false);
    const [hasLocationPermission, setHasLocationPermission] = useState(false);
    const [nearestLocationId, setNearestLocationId] = useState(null);
    const [acualLocation, setActualLocation] = useState({
        displayAddress: null,
        lastDisplayAddressUpdatedTime: null,
        nearestLocationId: null,
        actualLatitude: null,
        actualLongitude: null,
    });


    const InitiateTransfer = async () => {
        const response = await api.getCreateData("Invoices", {});
        const products = response?.Items || [];

        let line_item = null;

        const searchText = (scannerValue || "").toLowerCase();

        for (const product of products) {
            const serialNumberSearch = [
                ...(product.serial_numbers || []).map((serial_number) => serial_number.toLowerCase()),
            ]

            if (serialNumberSearch.length > 0) {
                const matched = serialNumberSearch.find((serial_number) => serial_number == searchText);

                if (matched) {
                    line_item = {
                        "item_id": product._id,
                        "hsn_or_sac": product.hsn_or_sac,
                        "description": product.description,
                        "account_id": product.sales_account_id,
                        "track_inventory": true,
                        "track_serial_number": true,
                        "track_batch_number": false,
                        "tax_group_id": product.tax_group_id,
                        "quantity": 1,
                        "item_price": 0,
                        "item_gross_total": 0,
                        "item_total": 0,
                        "discount_percentage": 0,
                        "discount_amount": 0,
                        "status": "Received",
                        "serial_numbers": [scannerValue]
                    }
                    break;
                }
            }
        }

        if (!line_item) {
            if (Platform.OS === 'web') {
                message.error("Serial no not found");
            } else {
                Alert.alert("Serial no not found");
            }
            return;
        }

        const data = {
            "scanningModule": true,
            "date": new Date(),
            "number": "Auto-Generated",
            "status": "Received",
            "from_location_id": null,
            "to_location_id": nearestLocationId,
            "receiving_employee_id": employee?._id,
            "line_items": [
                line_item
            ],
        }

        try {
            const response = await api.customRoute('Transfers/create', data);
            if (response.message) {
                if (Platform.OS === 'web') {
                    message.success(response.message);
                } else {
                    Alert.alert(response.message);
                }

                if (response.success) {
                    setScannerValue(null);
                }
            } else {
                if (Platform.OS === 'web') {
                    message.error("Something went wrong");
                } else {
                    Alert.alert("Something went wrong");
                }
            }
        } catch (error) {
            if (Platform.OS === 'web') {
                message.error(error.message);
            } else {
                Alert.alert(error.message);
            }
        }
    };

    useEffect(() => {
        if (scannerValue) {
            InitiateTransfer();
        }
    }, [scannerValue]);

    const allLocations = GlobalMasterStore((state) => state.locations) || [];

    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        const geolib = require("geolib");

        const distance = geolib.getDistance(
            { latitude: lat1, longitude: lon1 },
            { latitude: lat2, longitude: lon2 }
        );

        return distance / 1000;
    };

    const getNearestLocationBasedOnCurrentLocation = async (getAddressName = false) => {
        setFetchingLocation(true);

        if (!hasLocationPermission) {
            let { status } = await Location.requestForegroundPermissionsAsync();

            if (status !== 'granted') {
                if (Platform.OS === 'web') {
                    // message.error("Permission to access location was denied");
                } else {
                    Alert.alert("Permission to access location was denied");
                }
                setFetchingLocation(false);
                return;
            } else {
                setHasLocationPermission(true);
            }
        }

        let location = await Location.getCurrentPositionAsync({
            accuracy: Location.Accuracy.BestForNavigation,
        });
        let nearestLocation = null;
        let nearestDistance = null;

        for (let i = 0; i < allLocations.length; i++) {
            const distance = getDistanceFromLatLonInKm(location.coords.latitude, location.coords.longitude, allLocations[i].latitude, allLocations[i].longitude);

            if (nearestDistance === null || distance < nearestDistance) {
                nearestDistance = distance;
                nearestLocation = allLocations[i];
            }
        }

        if (nearestLocation) {
            setNearestLocationId(nearestLocation._id);
        }

        const oldLatitude = acualLocation.actualLatitude;
        const oldLongitude = acualLocation.actualLongitude;

        if (oldLatitude && oldLongitude) {
            const distance = getDistanceFromLatLonInKm(oldLatitude, oldLongitude, location.coords.latitude, location.coords.longitude);

            const lastDisplayAddressUpdatedTime = acualLocation.lastDisplayAddressUpdatedTime;

            if (distance < 0.1 && lastDisplayAddressUpdatedTime && (new Date().getTime() - lastDisplayAddressUpdatedTime.getTime()) < 300000) {
                setActualLocation({
                    displayAddress: acualLocation.displayAddress,
                    nearestLocationId: nearestLocation?._id,
                    actualLatitude: location.coords.latitude,
                    actualLongitude: location.coords.longitude,
                });

                setFetchingLocation(false);
                return;
            }
        }

        const response = await api.getFormattedAddress(location.coords.latitude, location.coords.longitude);

        setActualLocation({
            displayAddress: response.display_name,
            lastDisplayAddressUpdatedTime: new Date(),
            nearestLocationId: nearestLocation?._id,
            actualLatitude: location.coords.latitude,
            actualLongitude: location.coords.longitude,
        });

        setFetchingLocation(false);
    };

    const newRenderCardData = [
        {
            permission: permissions?.Appointments?.view,
            onPress: () => navigationFn("Appointments", {}),
            backgroundColor: tinycolor("#1945bb").toString(),
            icon: AppointmentsComponent,
            textSize: 12,
            textLabel: "Appointments"
        },
        {
            permission: permissions?.ProductionOrders?.view,
            onPress: () => navigationFn("ProductionOrders", {}),
            backgroundColor: tinycolor("#1945bb").toString(),
            icon: ProductionOrderComponent,
            textSize: 12,
            textLabel: "Production Order"
        },
        {
            permission: permissions?.ProductionWorkflows?.view,
            onPress: () => navigationFn("ProductionWorkflows", {}),
            backgroundColor: tinycolor("#2196F3").toString(),
            icon: ProductionWorkflowIconComponent,
            textSize: 12,
            textLabel: "Production Workflow"
        },
        {
            permission: permissions?.table?.view,
            onPress: () => navigationFn("table", {}),
            backgroundColor: tinycolor("#1945bb").toString(),
            icon: TableManagementComponentIcon,
            textSize: 12,
            textLabel: "Manage Restaurant"
        },
        {
            permission: permissions?.POS?.view,
            onPress: () => navigationFn("POS", {}),
            backgroundColor: tinycolor("#2196F3").darken(10).toString(),
            icon: PosComponentIcon,
            textSize: 12,
            textLabel: "Point of Sale"
        },
        {
            permission: permissions?.Kitchen?.view,
            onPress: () => navigationFn("kitchen", {}),
            backgroundColor: tinycolor("#673AB7").darken(10).toString(),
            icon: KitchenComponentIcon,
            textSize: 12,
            textLabel: "Kitchen"
        },
        {
            permission: permissions?.Leads?.view,
            onPress: () => navigationFn("Leads", {}),
            backgroundColor: tinycolor("rgb(46, 129, 144)").toString(),
            icon: LeadsComponentIcon,
            textSize: 12,
            textLabel: "Leads"
        },
        {
            permission: permissions?.Contacts?.view,
            onPress: () => navigationFn("Contacts", {}),
            backgroundColor: tinycolor("rgb(46, 129, 144)").toString(),
            icon: LeadsComponentIcon,
            textSize: 12,
            textLabel: "Contacts"
        },
        {
            permission: permissions?.Items?.view,
            onPress: () => navigationFn("Items", {}),
            backgroundColor: tinycolor("#673AB7").toString(),
            icon: ItemsComponentIcon,
            textSize: 12,
            textLabel: "Items"
        },
        {
            permission: permissions?.BroadcastNotifications?.view,
            onPress: () => navigationFn("BroadcastNotifications", {}),
            backgroundColor: tinycolor("#f65050").toString(),
            icon: BroadcastComponentIcon,
            textSize: 12,
            textLabel: "Broadcast"
        },
        {
            permission: permissions?.Quotations?.view,
            onPress: () => navigationFn("Quotations", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#706fd3").toString(),
            icon: SalesDashboardComponentIcon,
            textSize: 12,
            textLabel: "Quotations"
        },
        {
            permission: permissions?.SalesReturns?.view,
            onPress: () => navigationFn("SalesReturns", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#c80909").toString(),
            icon: SalesReturnComponentIcon,
            textSize: 12,
            textLabel: "Sale Return"
        },
        {
            permission: permissions?.PaymentReceived?.view,
            onPress: () => navigationFn("PaymentReceived", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#2ecc71").toString(),
            icon: CashInComponentIcon,
            textSize: 12,
            textLabel: "Receipts"
        },
        {
            permission: permissions?.PaymentMade?.view,
            onPress: () => navigationFn("PaymentMade", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#e74c3c").toString(),
            icon: CashOutComponentIcon,
            textSize: 12,
            textLabel: "Payments"
        },
        {
            permission: permissions?.MoneyTransfers?.view,
            onPress: () => navigationFn("MoneyTransfers", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#66a1b5").toString(),
            icon: MoneyTrasnferComponentIcon,
            textSize: 12,
            textLabel: "Money Transfers"
        },
        {
            permission: permissions?.Bills?.view,
            onPress: () => navigationFn("Bills", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#dd632e").toString(),
            icon: BillsComponentIcon,
            textSize: 12,
            textLabel: "Purchase"
        },
        {
            permission: permissions?.PurchaseReturns?.view,
            onPress: () => navigationFn("PurchaseReturns", {
                autoOpenNew: [16, 17].includes(organization_id) ? true : false,
            }),
            backgroundColor: tinycolor("#388fc7").toString(),
            icon: DebitNotesComponentIcon,
            textSize: 12,
            textLabel: "Purchase Return"
        }
    ];

    const [refreshing, setRefreshing] = useState(false);
    const [refreshCount, setRefreshCount] = useState(0);
    const locationInterval = useRef(null);

    const onRefresh = useCallback(() => {
        setRefreshing(true);
        setRefreshCount(Math.random());

        setTimeout(() => {
            setRefreshing(false);
        }, 1000);

        getNearestLocationBasedOnCurrentLocation();
    }, []);

    useEffect(() => {
        getNearestLocationBasedOnCurrentLocation();

        locationInterval.current = setInterval(() => {
            getNearestLocationBasedOnCurrentLocation();
        }, 60000);

        return () => {
            clearInterval(locationInterval.current);
        }
    }, []);

    const ApprovalRequestCard = (props) => {
        const radius = 10;
        const { data } = props;

        const readableModuleName = data.module_name?.replace(/([A-Z])/g, ' $1').trim();

        return (<Card flex className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap', borderRadius: radius, width: '100%' }}>
            <View padding-10 flex>
                <View marginB-10 row spread style={{ width: '100%' }}>
                    <View center backgroundColor="#FF9595" style={{ width: 60, height: 80, borderRadius: 10 }}>
                        <Text style={{ color: 'white', fontSize: 20 }}>{data.module_name[0]}</Text>
                    </View>

                    <View flex marginL-10>
                        <Text style={{ marginBottom: 5, fontSize: 16, fontFamily: 'SourceSansProBold' }}>
                            {readableModuleName} - {data.type}
                        </Text>
                        <View>
                            <Text lightCardTitle>Created by: </Text>
                            <Text darkCardTitle>
                                {data.created_by_employee?.name}
                            </Text>
                        </View>
                    </View>
                </View>

                <View marginB-10 style={{ width: '100%', height: 4, backgroundColor: '#EFF5FF', borderRadius: 4 }} />

                <View row={Platform.OS == "web"} spread style={{ width: '100%' }}>
                    <View>
                        <View row marginR-10>
                            <SecondaryButton label="View" onPress={() => {
                                if (Platform.OS == 'web') {
                                    setOpenModal({
                                        [data.module_name]: {
                                            isVisible: true,
                                            moduleName: data.module_name,
                                            id: data.module_id,
                                            isEdit: false,
                                            viewOnly: true,
                                            hideEditButton: true,
                                        }
                                    })
                                } else {
                                    navigationFn('New', {
                                        moduleName: data.module_name,
                                        id: data.module_id,
                                        viewOnly: true,
                                        isEdit: false,
                                        hideEditButton: true,
                                    });
                                }
                            }} />
                        </View>
                    </View>
                    <View row style={Platform.OS == 'web' ? {} : { marginTop: 10 }}>
                        <View row marginR-10>
                            <SecondaryButton label="Approve" onPress={() => {
                                approveFn();

                                async function approveFn() {
                                    const response = await api.customRoute("ApprovalRequests/action", {
                                        action: "approve",
                                        _id: data._id,
                                    });

                                    if (response.success) {
                                        if (Platform.OS == 'web') {
                                            message.success("Approved successfully");
                                        } else {
                                            Alert.alert("Approved successfully");
                                        }
                                        getPendingApprovalRequests();
                                    } else {
                                        if (Platform.OS == 'web') {
                                            message.error("Error in approving");
                                        } else {
                                            Alert.alert("Error in approving");
                                        }
                                    }
                                }
                            }} />
                        </View>
                        <View row>
                            <DangerButton label="Reject" onPress={() => {
                                rejectFn()

                                async function rejectFn() {
                                    try {
                                        const response = await api.customRoute("ApprovalRequests/action", {
                                            action: "reject",
                                            _id: data._id,
                                        })
                                        message.success("Rejected successfully")
                                        getPendingApprovalRequests()
                                    } catch (e) {
                                        message.success("Rejected successfully")
                                        getPendingApprovalRequests()
                                    }
                                }
                            }} />
                        </View>
                    </View>
                </View>
            </View>
        </Card>);
    };

    const [approvalRequests, setApprovalRequests] = useState([]);
    const [prefs, setPrefs] = useState({});

    const getOrganizationSettings = async () => {
        const data = await api.customRoute("getOrganizationPrefs", {
            module_name: "Organization"
        });

        setPrefs(data);
    };

    const getPendingApprovalRequests = async () => {
        const response = await api.customRoute("ApprovalRequests/action", {
            action: "getPendingApprovalRequests",
        });
        setApprovalRequests(response.data);
    };

    useEffect(() => {
        getPendingApprovalRequests();
        getOrganizationSettings();
    }, [refreshCount]);

    return (
        <LayoutScreen>
            <View flex>
                <View style={{
                    height: Dimensions.get("window").height - (Platform.OS == 'web' ? 100 : 80),
                    maxHeight: Dimensions.get("window").height - (Platform.OS == 'web' ? 100 : 80),
                    margin: Platform.OS == 'web' ? 20 : 10,
                    marginRight: Platform.OS == 'web' ? 20 : 10,
                }}>
                    <ScrollView
                        style={{
                            flexGrow: 1,
                            minHeight: (Platform.OS == 'web' && approvalRequests && approvalRequests.length > 0) ? 270 : null,
                        }}
                        refreshControl={
                            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
                        }>
                        {/* <View margin-10 marginB-0>
                            <LinearGradient colors={['#fefaf1', '#f2eefa']} style={{
                                padding: 15,
                                borderRadius: 10,
                                position: 'relative',
                            }}>
                                <View row={Platform.OS == 'web'} spread={Platform.OS == 'web'}>
                                    <View row>
                                        <View>
                                            <Avatar
                                                size={50}
                                                label={employee?.name ? employee?.name[0].toUpperCase() + employee?.name[1].toUpperCase() : "EMP"}
                                                containerStyle={{
                                                    backgroundColor: "#FF9595"
                                                }}
                                                backgroundColor={"#FF9595"}
                                                labelColor="white"
                                            />
                                        </View>
                                        <View marginL-10>
                                            <Text h1>Welcome, {employee?.name}</Text>
                                            <Text tabHeading>{employee?.employee_code}</Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                }}>
                                    <Text
                                        style={{
                                            fontSize: 12,
                                            color: '#cccccc',
                                            fontFamily: 'SourceSansProSemiBold',
                                            opacity: 0.8,
                                        }}
                                    >v1.0.7</Text>
                                </View>
                            </LinearGradient>
                        </View> */}
                        <View style={{
                            paddingTop: 10,
                            flex: 1,
                        }}>
                            <View >
                                <View>

                                    {Platform.OS != 'web' && <Carousel
                                        containerStyle={{ height: 200 }}
                                        itemSpacings={10}
                                        onChangePage={() => { }}
                                    // pageControlPosition={'under'}
                                    >
                                        {permissions?.CheckInCard?.view && <TodaysAttendanceCard
                                            displayAddress={acualLocation.displayAddress}
                                            nearestLocationId={acualLocation.nearestLocationId}
                                            actualLatitude={acualLocation.actualLatitude}
                                            actualLongitude={acualLocation.actualLongitude}
                                            employee={employee} employee_id={employee?._id}
                                            refreshCount={refreshCount} />}
                                        {permissions?.BalanceCard?.view && <EmployeeBalanceCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} />}
                                        {permissions?.CollectionSummaryCard?.view && <CollectionSummaryCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} />}
                                        {permissions?.GlobalCollectionSummaryCard?.view && <GlobalCollectionSummaryCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} />}
                                    </Carousel>}

                                    {/* {Platform.OS == 'web' && <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={{
                                        padding: 10,
                                        paddingLeft: -20,
                                        paddingRight: 30
                                    }}>
                                        {(Platform.OS != 'web' && permissions?.CheckInCard?.view) ? <TodaysAttendanceCard
                                            displayAddress={acualLocation.displayAddress}
                                            nearestLocationId={acualLocation.nearestLocationId}
                                            actualLatitude={acualLocation.actualLatitude}
                                            actualLongitude={acualLocation.actualLongitude}
                                            employee={employee} employee_id={employee?._id}
                                            refreshCount={refreshCount} /> : null}
                                        {permissions?.BalanceCard?.view ? <EmployeeBalanceCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} /> : null}
                                        {permissions?.CollectionSummaryCard?.view ? <CollectionSummaryCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} /> : null}
                                        {permissions?.GlobalCollectionSummaryCard?.view ? <GlobalCollectionSummaryCard employee={employee} employee_id={employee?._id} refreshCount={refreshCount} /> : null}
                                    </ScrollView>} */}
                                </View>
                            </View>
                        </View>

                        {approvalRequests && approvalRequests.length > 0 && <View style={{
                            flex: 1,
                        }}>
                            <View marginL-10>
                                <View>
                                    <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={{
                                        padding: 10,
                                        paddingLeft: -20,
                                        paddingRight: 30
                                    }}>
                                        {approvalRequests.map((data, index) => {
                                            return <View style={{
                                                width: 320,
                                                height: 220,
                                            }}
                                                key={index.toString()}
                                            >
                                                <ApprovalRequestCard data={data} />
                                            </View>
                                        })}
                                    </ScrollView>
                                </View>
                            </View>
                        </View>}
                    </ScrollView>

                    <ScrollView style={{
                        flexGrow: 1000,
                        paddingBottom: Platform.OS == 'web' ? 0 : 0,
                    }}>
                        {Platform.OS != 'web' && permissions?.POS?.view && <View padding-8>
                            <Card center onPress={() => navigationFn("POS", {})} style={{
                                height: 150,
                                backgroundColor: "#1071ed",
                                marginBottom: 10,
                                borderRadius: 20,
                                position: 'relative',
                            }}>
                                <View style={{
                                    position: 'absolute',
                                    top: 20,
                                    left: 20,
                                    transform: [{ scale: 1.2 }],
                                }}>
                                    <Svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={380}
                                        height={380}
                                        fill="none"
                                    >
                                        <Path
                                            fill="#fff"
                                            fillOpacity={0.1}
                                            d="M111.917 118.5a13.17 13.17 0 0 1 9.311 3.856 13.17 13.17 0 0 1 0 18.621 13.17 13.17 0 0 1-18.621 0 13.167 13.167 0 0 1-3.856-9.31c0-7.308 5.859-13.167 13.166-13.167ZM6.584 13.167h21.527L34.3 26.333h97.367a6.582 6.582 0 0 1 6.584 6.584c0 1.119-.33 2.238-.79 3.291l-23.569 42.594c-2.238 4.016-6.583 6.781-11.521 6.781H53.326L47.4 96.314l-.198.79a1.646 1.646 0 0 0 1.646 1.646h76.235v13.167h-79A13.168 13.168 0 0 1 32.917 98.75c0-2.304.593-4.477 1.58-6.32l8.954-16.13-23.7-49.967H6.584V13.167Zm39.5 105.333a13.167 13.167 0 1 1-13.167 13.167c0-7.308 5.86-13.167 13.167-13.167Zm59.25-46.083L123.636 39.5H40.422L55.96 72.417h49.375Z"
                                        />
                                    </Svg>
                                </View>

                                <View row centerV>
                                    <Svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={31}
                                        height={30}
                                        fill="none"
                                        {...props}
                                    >
                                        <Path
                                            fill="#fff"
                                            d="M24.5 24a3 3 0 1 1-3 3c0-1.665 1.335-3 3-3ZM.5 0h4.905l1.41 3H29a1.5 1.5 0 0 1 1.5 1.5c0 .255-.075.51-.18.75l-5.37 9.705a3.016 3.016 0 0 1-2.625 1.545H11.15L9.8 18.945l-.045.18a.375.375 0 0 0 .375.375H27.5v3h-18a3 3 0 0 1-3-3c0-.525.135-1.02.36-1.44l2.04-3.675L3.5 3h-3V0Zm9 24a3 3 0 1 1-3 3c0-1.665 1.335-3 3-3ZM23 13.5 27.17 6H8.21l3.54 7.5H23Z"
                                        />
                                    </Svg>

                                    <Text marginL-5 style={{
                                        color: 'white',
                                        fontSize: 40,
                                        fontFamily: 'SourceSansProBold',
                                    }}>POS</Text>
                                </View>
                                <Text style={{
                                    color: 'white',
                                    fontSize: 14,
                                }}>Start selling products</Text>
                            </Card>
                        </View>}
                        <View row style={{
                            flexWrap: 'wrap',
                            width: '100%',
                        }}>
                            {newRenderCardData.map((cardData, index) => {
                                return cardData.permission ? <View
                                    key={index}
                                    style={{
                                        width: Platform.OS == 'web' ? '14.2%' : '33%',
                                    }}
                                    padding-4>
                                    <CustomCard
                                        permission={cardData.permission}
                                        onPress={cardData.onPress}
                                        backgroundColor={cardData.backgroundColor}
                                        Icon={cardData.icon}
                                        textSize={cardData.textSize}
                                        textLabel={cardData.textLabel}
                                    />
                                </View> : false;
                            })}
                        </View>

                        {permissions?.AccountingReports?.view && <View marginT-10>
                            <HomeDashboard />
                        </View>}

                        {organization_id == '25' && <View marginT-10 marginH-10>
                            <Row>
                                <Col width={Platform.OS === 'web' ? '100%' : '100%'}>
                                    {Label({ label: "Live Youtube Link" })}
                                    <CustomTextField value={prefs.live_youtube_link} onChange={(value) => {
                                        setPrefs({
                                            ...prefs,
                                            live_youtube_link: value
                                        });
                                    }} />
                                </Col>
                            </Row>
                            <View>
                                <PrimaryButton label="Save" onPress={async () => {
                                    const data = await api.customRoute("saveOrganizationPrefs", {
                                        module_name: "Organization",
                                        prefs: prefs
                                    });

                                    if (data.message) {
                                        if (Platform.OS === 'web') {
                                            message.success("Link Updated Successfully");
                                        } else {
                                            Alert.alert("Success", "Link Updated Successfully!");
                                        }
                                    } else {
                                        if (Platform.OS === 'web') {
                                            message.error(data.error);
                                        } else {
                                            Alert.alert("Error", data.error);
                                        }
                                    }
                                }} />
                            </View>
                        </View>}
                    </ScrollView>
                </View>
            </View>
        </LayoutScreen >
    )
})

export default HomeScreen



